import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 *  
 * @desc Get Admin system notification type list
 */
export function getAdminNotificatiosAction() {
   
    let url = UrlConstants.adminSysNotification;
    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.ADMIN_SYS_NOTIFICATION,
                    sysNotifications : response.data
                });
            }
            else {
                dispatch({
                    type: types.ADMIN_SYS_NOTIFICATION,
                    sysNotifications: {}
                });
            }
            return response;
        });       
    }
}


/**
 *  
 * @desc Get All notification list by user
 */
export function getNotificatioListAction(offset) {   
   
    let url = UrlConstants.userNotification + "?offset="+offset;
    return function (dispatch) {
        return APIUtil.getMethod(url,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.USER_NOTIFICATIONS,
                    userNotifications : response.data
                });
            }
            else {
                dispatch({
                    type: types.USER_NOTIFICATIONS,
                    userNotifications: {}
                });
            }
            return response;
        });       
    }
}
/**
 * Get notification setting for user
 */
export function getUserNotificationSettingsAction() {
    let url = UrlConstants.userNotificationListing;
    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.USER_NOTIFICATIONS_SETTINGS,
                    usernotificationSettings : response.data
                });
            }
            else {
                dispatch({
                    type: types.USER_NOTIFICATIONS_SETTINGS,
                    usernotificationSettings: {}
                });
            }
            return response;
        });       
    }
}

/**
 * @desc api call for update notification settings
 * @param {*} data 
 */
export function updateSettingsAction(data) {
    let url = UrlConstants.userNotificationListing 
    return function (dispatch) {
        return APIUtil.putMethod(url,data,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.UPDATE_NOTIFICATIONS_SETTINGS,
                    updatedSettings : response.data
                });
            }
            else {
                dispatch({
                    type: types.UPDATE_NOTIFICATIONS_SETTINGS,
                    updatedSettings: {}
                });
            }
            return response;
        });       
    }
}


/**
 *  
 * @desc Clear All notifications by user
 */
export function clearNotificationsAction() {
    let url = UrlConstants.userNotification;
    return function (dispatch) {
        return APIUtil.deleteMethod(url,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.CLEAR_NOTIFICATIONS,
                    clearNotiRes : response.data
                });
            }
            else {
                dispatch({
                    type: types.CLEAR_NOTIFICATIONS,
                    clearNotiRes: {}
                });
            }
        });       
    }
}

/**
 *  
 * @desc Clear All notifications by user
 */
export function readNotificationsAction(data) {
    let url = UrlConstants.userNotification;
    return function (dispatch) {
        return APIUtil.putMethod(url,data,true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.READ_NOTIFICATIONS,
                    readNotiRes : response.data
                });
            }
            else {
                dispatch({
                    type: types.READ_NOTIFICATIONS,
                    readNotiRes: {}
                });
            }
        });       
    }
}

/**
 *  
 * @desc Get unread notification count
 */
export function getNotificatiosCntAction() {
   
    let url = UrlConstants.notificationUnreadCnt;
    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            if (response.status === code.OK) {
               return !!response.data.totalCount ? response.data.totalCount :0
            }
            else {
               return 0;
            }
        });       
    }
}